<div class="card">
    <h1>Last ned ditt boligkompass</h1>
    <p class="description">Lagre resultatene dine slik at du kan gå gjennom anbefalingene når det passer deg.</p>
<button (click)="tilDelBoligkompass()" hb-button class="button">
    Lagre ditt boligkompass her
</button>
</div>
